<template>
  <div class="md:flex md:justify-center">
    <template v-if="questionListMenu">
      <client-menu
        :all-questions="allQuestions"
        :on-resize="onResize"
        :question-list-menu="questionListMenu"
        :examination="examination"
        :type="type"
        :count-answer="countAnswer"
        :questions="questions"
        :is-clicked-question-list="isClickedQuestionList"
        :question-index="questionIndex"
        :answers-arr="answersArr"
        @confirmation="onOpenConfirmationModal"
        @assign-index="assignIndex"
        @on-clicked-question-list-menu="onClickedQuestionListMenu"
        @link-click="onClickedQuestionList" />
    </template>
    <div class="md:py-8 md:w-4/6">
      <question
        :all-questions="allQuestions"
        :select-answer="selectAnswer"
        :answers-arr="answersArr"
        :on-resize="onResize"
        :question-list-menu="questionListMenu"
        :examination="examination"
        :type="type"
        :count-answer="countAnswer"
        :start-answer-time="startAnswerTime"
        :limit-times="limitTimes"
        :question-index="questionIndex"
        :is-select-condition="isSelectCondition"
        @assign-answer="assignAnswer"
        @button-click="onClickedButton"
        @sum-index="sumIndex"
        @confirmation="onOpenConfirmationModal"
        @on-clicked-question-list-menu="onClickedQuestionListMenu" />
    </div>
  </div>
</template>
<script setup>
import {
  ref, computed, onMounted, onBeforeUnmount, reactive,
} from 'vue'
import Swal from 'sweetalert2'
import { Inertia } from '@inertiajs/inertia'
import ClientMenu from './Partials/ClientMenu'
import Question from './Partials/Question'
import AppClientLayout from '@/Layouts/AppClientLayout'
import DialogModal from '../../Common/DialogModal'
import WhiteButton from '../../Common/Button'

const props = defineProps({
  questions: {
    type: Array,
    default: () => [],
  },
  allQuestions: {
    type: Array,
    default: () => [],
  },
  examination: {
    type: Object,
    default: () => {},
  },
  type: {
    type: Number,
    default: 0,
  },
  startAnswerTime: {
    type: String,
    default: '',
  },
  limitTimes: {
    type: Object,
    default: () => {},
  },
})

const answers = 'answers'
const answersArr = ref([])
const countAnswer = ref(0)
const isSelectCondition = ref(true)
const questionIndex = ref(0)
const selectAnswer = reactive({
  question_id: null,
  answer_type: null,
  examination_type: null,
})

const saveLocalStorage = () => {
  const json = localStorage.getItem(answers)
  const array = json != null ? JSON.parse(json) : []
  if (selectAnswer.answer_type) {
    answersArr.value = array
    const index = answersArr.value.findIndex((element) => element.question_id === selectAnswer.question_id)
    if (index > -1) {
      answersArr.value[index].answer_type = selectAnswer.answer_type
    } else {
      answersArr.value.push(selectAnswer)
    }

    localStorage.setItem(answers, JSON.stringify(answersArr.value))
    answersArr.value = []
  }
  countAnswer.value = array.length
  answersArr.value = JSON.parse(localStorage.getItem(answers))
}

const assignAnswer = (index) => {
  selectAnswer.question_id = props.allQuestions[questionIndex.value].id
  selectAnswer.answer_type = props.allQuestions[questionIndex.value].pivot.choices_order[index]
  selectAnswer.examination_type = props.type
  isSelectCondition.value = false
}

const sumIndex = (number) => {
  saveLocalStorage()
  questionIndex.value += number
  isSelectCondition.value = true
}

const assignIndex = (number, selectedAnswer) => {
  saveLocalStorage()
  questionIndex.value = number
  isSelectCondition.value = true
}

const isButtonClick = ref(false)
const isClickedQuestionList = ref(false)

const onClickedQuestionList = () => {
  isClickedQuestionList.value = true
  isButtonClick.value = false
}

const redrawFlag = ref(true)

const onClickedButton = () => {
  isClickedQuestionList.value = false
  isButtonClick.value = true

  redrawFlag.value = false
}

const onFinishedExamination = () => {
  const form = Inertia.form({
    answerList: answersArr.value,
    examination: props.examination,
    type: props.type,
  })
  form.post('/finish')
  // form.post('/finish', {
  //   onSuccess: () => {
  //     localStorage.clear()
  //   },
  // })
}

const isUnanswered = computed(() => props.allQuestions.length - countAnswer.value > 0)

const onOpenConfirmationModal = () => {
  saveLocalStorage()

  Swal.fire({
    icon: 'question',
    title: '試験を終了します。',
    text: 'よろしいですか？',
    showCancelButton: true,
    confirmButtonText: 'はい',
    cancelButtonText: 'いいえ',
  }).then((result) => {
    if (result.isConfirmed && isUnanswered.value) {
      Swal.fire({
        icon: 'question',
        title: '未解答の問題があります。',
        text: '本当によろしいですか？',
        showCancelButton: true,
        confirmButtonText: 'はい',
        cancelButtonText: 'いいえ',
      }).then((result1) => {
        if (result1.isConfirmed) {
          onFinishedExamination()
        }
      })
    } else if (result.isConfirmed) {
      onFinishedExamination()
    }
  })
}

window.history.pushState(null, null, null)
window.addEventListener('popstate', () => {
  window.history.pushState(null, null, null)
})

const questionListMenu = ref(false)
const onClickedQuestionListMenu = () => {
  questionListMenu.value = !questionListMenu.value
}
const onResize = ref(false)
const switchByWidth = () => {
  if (window.matchMedia('(max-width: 770px)').matches) {
    onResize.value = true
    questionListMenu.value = false
  } else {
    onResize.value = false
    questionListMenu.value = true
  }
}
onMounted(() => {
  const json = localStorage.getItem(answers)
  const array = json != null ? JSON.parse(json) : []
  answersArr.value = array
  countAnswer.value = array.length
  localStorage.setItem('examination', JSON.stringify({
    examination_id: props.examination.id,
    examination_type: props.type,
  }))
  switchByWidth()
  window.addEventListener('resize', switchByWidth)
})
onBeforeUnmount(() => {
  window.addEventListener('resize', switchByWidth)
})
</script>
